import React from "react";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  isAdmin: boolean;
  children: React.ReactNode;
}

export default function ProtectedRoute({ isAdmin, children }: ProtectedRouteProps) {
  if (!isAdmin) {
    // In v6, we use <Navigate /> instead of <Redirect />
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
